var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.classes
      ? (_vm.classes + " " + (_vm.withoutBackground ? 'without-background' : ''))
      : ("" + (_vm.withoutBackground ? 'without-background' : '')),style:(("" + (_vm.width ? ("width: " + _vm.width) : ""))),on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }